import _ from 'lodash'
import {productSummary, groupedReport, clientSummary, search} from '../services/api'
import odataMixin from '@/core/store/mixin/odata'
import crudMixin from '@/core/store/mixin/crud'
import {dateGrouped} from "../services/api";
import Utils from "@/core/utils/utils"
import moment from "moment";
import apiProductType from "@/core/enums/apiProductType";

const getFieldsColumns = (data) => {
  const fieldsSet = new Set();
  data.forEach(item => {
    // eslint-disable-next-line complexity
    apiProductType.forEach(key =>{
      if (item[key]!==null && item[key]!==undefined && item[key]!=='') {
        fieldsSet.add(key);
      }
    })
  });

  return Array.from(fieldsSet);
};

export default _.merge(
  odataMixin(search),
  crudMixin(search),
  {
    actions: {
      getDateGrouped({commit}, payload) {
        return dateGrouped(payload.params.type, payload)
          .then((response) => response.data)
          .then((data) => {
            const filledData = Utils.addEmptyRows(
              Utils.getListOfDates(payload.params.type, payload.filter.range.from, payload.filter.range.to),
              data,
              'datetime'
            );
            return _.reverse(_.sortBy(filledData, (i) => moment(i.datetime).toDate()))
          }).then(data => {
            return {
              data: data,
              columns: getFieldsColumns(data)
            }
          })
      },
        getGrouped({commit}, payload) {
            return groupedReport(payload.params.type, payload)
                .then((response) => response.data)
                .then((data) => {
                    return _.reverse(_.sortBy(data, (i) => i.totalCallCount))
                })
                .then(data => {
                    return {
                        data: data,
                        columns: getFieldsColumns(data)
                    }
                })
        },
      productSummary({commit}, payload) {
        return productSummary(payload.$filter)
          .then((response) => response.data)
      },
      clientSummary({commit}, payload) {
        return clientSummary(payload.$filter)
          .then((response) => response.data)
      },
    },
    namespaced: true,
  },
)
